export default "__VITE_ASSET__BOSJHsTH__"